import { useEffect, useMemo, useState } from "react";
import { SearchByOption, SearchConfig } from "../../../types/search";

type SearchFieldProps = {
  searchByOptions: SearchByOption[];
  onChangeSearchBy: (option: SearchConfig) => void;
  onSearch: (value: string) => void;
};

export const useSearchField = (props: SearchFieldProps) => {
  const { searchByOptions, onChangeSearchBy, onSearch } = props;

  const [selectedSearchByOption, setSelectedSearchByOption] = useState<SearchConfig>();

  const flatOptions = useMemo(
    () => searchByOptions?.flatMap((option) => ("options" in option ? option.options : [option])) ?? [],
    [searchByOptions]
  );

  useEffect(() => {
    if (!flatOptions.length) return;

    const defaultOption = flatOptions.find((opt) => opt.default) ?? flatOptions[0];
    setSelectedSearchByOption((prev) => (prev?.value ? prev : defaultOption));
  }, [flatOptions]);

  const isSelectSearch = useMemo(() => {
    return flatOptions.some(
      (option) => option.value === selectedSearchByOption?.value && option.controlType === "select"
    );
  }, [flatOptions, selectedSearchByOption]);

  const handleSearchByChange = (option: SearchConfig) => {
    if (option?.value) {
      setSelectedSearchByOption(option);
      onChangeSearchBy(option);
    }
  };

  const handleSearch = (value: string) => onSearch(value?.trim());

  return { isSelectSearch, selectedSearchByOption, handleSearchByChange, handleSearch };
};
